export const TRAILER_SCROLL_PADDING_SLACK_PX = 8;

/**
 * Returning 0 keeps today's CSS and behavior for every block that renders no trailer, so this
 * fix is self-scoping to blocks that actually have a clipped trailer.
 *
 * The slack exists because Chrome's center-if-needed focus alignment lands a few px short of the
 * content bottom; overshoot is harmless since the browser clamps at `maxScrollTop`.
 */
export const trailerScrollPaddingPx = ({
  trailerHeightPx,
  isReport,
  inPrintMode,
  isExpanded,
  customExpandsByRowSlice,
}: {
  trailerHeightPx: number;
  isReport: boolean;
  inPrintMode: boolean;
  isExpanded: boolean;
  customExpandsByRowSlice: boolean;
}): number =>
  trailerHeightPx > 0 && isReport && !inPrintMode && !isExpanded && !customExpandsByRowSlice
    ? trailerHeightPx + TRAILER_SCROLL_PADDING_SLACK_PX
    : 0;
